<template>
  <div
    id="product-details"
    class="container wp_AllPageMarginTop pb-4 position-relative"
				style="min-height: 90vh"
  >
    <!--<loading-->
      <!--:active.sync="showLoader"-->
      <!--:can-cancel="false"-->
      <!--:is-full-page="true"-->
      <!--:opacity=1-->
      <!--loader="dots"-->
    <!--&gt;-->
    <!--</loading>-->
			<page-loader v-if="showLoader">
			</page-loader>
			<product-details-section
				:productData=product
				:deliveryBasedVendorSelected="deliveryBasedVendorSelected"
				@commentReview="getProductDetails($event)"
					v-else
			/>
    <!-- <product-specification-section :product=product>
    </product-specification-section> -->
    <!-- <product-rating-section
      :product=product
      @commentReview="getProductDetails($event)"
    >
    </product-rating-section> -->
    <!--<load-more-section>-->
    <!--</load-more-section>-->
  </div>
</template>

<script>
// import Loading from 'vue-loading-overlay'
import { mapGetters } from 'vuex'
import { productApi } from '@/services/ApiServices/productApi'
import { store } from '@/store/store'
import ProductDetailsSection from './container/ProductDetailsSection'
import PageLoader from '../../shared/loader/pageLoader'

export default {
	components: {
		PageLoader,
		ProductDetailsSection
		// ProductSpecificationSection,
		// Loading
	},
	data () {
		return {
			stock: 0,
			cartProduct: {},
			product: {},
			promotion: {},
			showLoader: true,
			deliveryBasedVendorSelected: false
		}
	},
	beforeRouteEnter (to, from, next) {
		document.title = to.query.productName
		document.description = 'product has unique features'
		next()
	},
	beforeRouteUpdate (to, from, next) {
		document.title = to.query.productName
		document.description = 'product has unique features'
		next()
	},
	beforeMount () {
		store.dispatch('buynow/deleteFromBuyNow')
		this.getProductDetails(this.$route.query.productId, this.$route.query.productCategoryId)
	},
	mounted () {
		this.$nextTick(() => {
			// $('#glasscase')
			//   .glassCase({
			//     thumbsPosition: 'bottom',
			//     widthDisplay: 560,
			//   });
		})
		const invent = this.product.vendor_product_inventories
		if (invent && invent.length > 0) {
			this.stock = invent[0].available_stock
		}
	},
	computed: {
		...mapGetters('productselected', ['getSelectedProduct']),
		...mapGetters('user', ['isAuthenticated']),
		...mapGetters('cart', ['getOrderCart']),
		// ...mapGetters('recentview', ['getRecentData']),
		promotionalPrices () {
			const promotions = this.product.vendor_product_inventories[0].promotional_prices
			if (promotions && promotions.length > 0) {
				return promotions[0]
			}
			return []
		},
		categoryBreadCrumb () {
			// if (this.product && this.product.parents) {
			const parentCategories = this.product.parents
			if (parentCategories) {
				return parentCategories.sort((a, b) => a.depth - b.depth)
			}
			return {
				// category_id: null,
				name: null
			}

			// }
			// return [];
		}
	},
	methods: {
		// ...mapActions('recentview', ['setRecentData'])
		getProductDetails (productId, categoryId) {
			this.showLoader = true
			const productIds = []
			productIds.push(productId)
			productApi.getProductsByIds(productIds, '', categoryId)
				.then((res) => {
					if (res) {
						if (res.data && res.data.length > 0) {
							this.product = JSON.parse(JSON.stringify(this.getSelectedProduct[0]))
							this.showLoader = false
							this.$forceUpdate()
							this.$nextTick(() => {
								// $('#glasscase')
								//   .glassCase({
								//     thumbsPosition: 'bottom',
								//     widthDisplay: 560,
								//   });

								// Exclude feature: Check Vendor Availability

								// orderApi.checkVendorAvailability()
								//   .then(() => {
								//     this.deliveryBasedVendorSelected = true;
								//   });

								// Exclude feature: Check Vendor Availability
							})
						} else {
							this.$router.push('/')
						}
					}
				})
		},
		getProductSepecification () {
			const specifications = this.product.product_specification
			if (specifications && specifications.specifications.length > 0) {
				return specifications.specifications
			}
			return null
		}
	},
	watch: {
		$route: {
			handler (val) {
				this.getProductDetails(this.$route.query.productId)
			},
			deep: true
		},
		getSelectedProduct: {
			handler (val) {
				this.product = {}
				if (this.getSelectedProduct && this.getSelectedProduct.length > 0) {
					this.product = JSON.parse(JSON.stringify(this.getSelectedProduct[0]))
				}
			},
			deep: true
		}
	}
}
</script>
